var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.153,
    height: 44.724,
    viewBox: "0 0 45.153 44.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0a9aea;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41431",
    "data-name": "Group 41431",
    transform: "translate(-10760.846 -2738.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42538",
    "data-name": "Path 42538",
    className: "cls-1",
    d: "M21.261,42.283a2.97,2.97,0,0,1,2.631,0l3.971,2.248a1.461,1.461,0,0,0,2.019-.593L32.007,39.9a2.97,2.97,0,0,1,2.213-1.422l4.556-.256a1.461,1.461,0,0,0,1.378-1.59l-.4-4.546a2.969,2.969,0,0,1,1.093-2.393l3.694-2.678a1.461,1.461,0,0,0,.3-2.083l-2.79-3.611a2.97,2.97,0,0,1-.374-2.6l1.66-4.25a1.461,1.461,0,0,0-.874-1.914l-4.3-1.529a2.97,2.97,0,0,1-1.722-1.988l-.9-4.473a1.461,1.461,0,0,0-1.77-1.138L29.33,4.464a2.97,2.97,0,0,1-2.524-.741L23.629.447a1.461,1.461,0,0,0-2.1,0L18.348,3.723a2.97,2.97,0,0,1-2.524.741L11.38,3.426A1.461,1.461,0,0,0,9.61,4.564l-.9,4.473a2.97,2.97,0,0,1-1.723,1.988l-4.3,1.529a1.461,1.461,0,0,0-.874,1.914l1.66,4.25a2.97,2.97,0,0,1-.374,2.6L.308,24.932a1.461,1.461,0,0,0,.3,2.083L4.3,29.694a2.969,2.969,0,0,1,1.093,2.393L5,36.632a1.461,1.461,0,0,0,1.378,1.59l4.556.256A2.97,2.97,0,0,1,13.146,39.9l2.125,4.038a1.461,1.461,0,0,0,2.019.593Z",
    transform: "translate(10760.846 2738.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42539",
    "data-name": "Path 42539",
    className: "cls-2",
    d: "M244.931,278.5a1.668,1.668,0,0,0-2.355.152L232.5,290.113l-5.077-5.775a1.668,1.668,0,1,0-2.506,2.2l6.33,7.2a1.668,1.668,0,0,0,2.355.152,1.686,1.686,0,0,0,.145-.145l.006-.007,11.326-12.885a1.668,1.668,0,0,0-.152-2.355",
    transform: "translate(10548.42 2474.368)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified_icon.dbb71263993a45a35eee714f6715311e.svg";
export { ForwardRef as ReactComponent };